/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import React from 'react';
import PropTypes from 'prop-types';
import { Icon, FlexRow, FlexCol, Label, Button } from 'sarsaparilla';

export default class VehicleItem extends React.Component {
    static propTypes = {
        handleRemove: PropTypes.func,
        handleChange: PropTypes.func,
        vehicle: PropTypes.any,
        index: PropTypes.number,
        descriptionRequired: PropTypes.bool,
        licensePlateRequired: PropTypes.bool,
        licenseStateRequired: PropTypes.bool,
    };

    constructor(props) {
        super(props);
        this.onClickRemove = this.onClickRemove.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.refrence = React.createRef();
    }

    componentDidMount() {
        if (this.refrence && this.refrence.current) {
            this.refrence.current.focus();
        }
    }

    onClickRemove(e) {
        e.preventDefault();
        const index = parseInt(this.props.index, 10);
        this.props.handleRemove(index);
    }

    handleChange(event) {
        const input = event.target.value;
        const id = event.target.id;
        this.props.handleChange(this.props.index, id, input);
    }

    render() {
        const { descriptionRequired, licensePlateRequired, licenseStateRequired, index } =
            this.props;
        const readableIndex = index + 1;
        return (
            <div className="per-form-group-item">
                <FlexRow alignItems="center">
                    <FlexCol md={4}>
                        <div className="rec-form-item-wrap">
                            <Label
                                htmlFor={`vehicle-description-${index + 1}`}
                                isRequired={descriptionRequired}
                            >
                                Description/Make and Model
                            </Label>
                            <input
                                ref={this.refrence}
                                aria-label={`vehicle-description-${readableIndex}`}
                                type="text"
                                id={`vehicle-description-${readableIndex}`}
                                value={this.props.vehicle.description}
                                onChange={this.handleChange}
                            />
                        </div>
                    </FlexCol>
                    <FlexCol md={4}>
                        <div className="rec-form-item-wrap">
                            <Label
                                htmlFor={`vehicle-license-plate-${readableIndex}`}
                                isRequired={licensePlateRequired}
                            >
                                License Plate
                            </Label>
                            <input
                                aria-label={`vehicle-license-plate-${readableIndex}`}
                                type="text"
                                id={`vehicle-license-plate-${readableIndex}`}
                                value={this.props.vehicle.license_plate}
                                onChange={this.handleChange}
                            />
                        </div>
                    </FlexCol>
                    <FlexCol md={2}>
                        <div className="rec-form-item-wrap">
                            <Label
                                htmlFor={`vehicle-license-state-${readableIndex}`}
                                isRequired={licenseStateRequired}
                            >
                                State
                            </Label>
                            <input
                                aria-label={`vehicle-license-state-${readableIndex}`}
                                type="text"
                                id={`vehicle-license-state-${readableIndex}`}
                                value={this.props.vehicle.license_state}
                                onChange={this.handleChange}
                            />
                        </div>
                    </FlexCol>
                    <FlexCol md={2} alignSelf="end">
                        <div className="per-form-group-item-remove">
                            <Button
                                appearance="subtle-danger"
                                onClick={this.onClickRemove}
                                iconBeforeElement={<Icon iconName="delete" />}
                                screenReaderTextBefore={`Remove row ${readableIndex} from the vehicle list`}
                            >
                                Delete
                            </Button>
                        </div>
                    </FlexCol>
                </FlexRow>
            </div>
        );
    }
}
